import React from 'react';

// Props:
// - value: current filter string
// - onChange: fn(newValue)
// - options: optional array of {label, value}
const DEFAULT_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Active', value: 'Active' },
  { label: 'Outstanding balance', value: 'Owing' },
  { label: 'Overdue', value: 'Overdue' },
  { label: 'Due in 7 days', value: 'Due Soon' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Awaiting Client', value: 'Awaiting Client' },
  { label: 'Awaiting Staff', value: 'Awaiting Staff' },
  { label: 'Awaiting Approval', value: 'Awaiting Approval' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Outstanding', value: 'Outstanding' },
  { label: 'Bad Debt', value: 'Bad Debt' },
  { label: 'Written off', value: 'Written off' },
  { label: 'Paid Off', value: 'Paid Off' },
  { label: 'Rejected', value: 'Rejected' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Terminated', value: 'Terminated' },
  // The affordability check's decision (ML.S.4), whatever the loan's status.
  { label: 'Affordability: Approved', value: 'affordability:Approved' },
  { label: 'Affordability: Manual review', value: 'affordability:ManualReview' },
  { label: 'Affordability: Declined', value: 'affordability:Declined' },
];

// `selectClassName` lets a cramped host (the loans panel beside a client) size
// the control down without changing it everywhere else.
const LoansStatusDropdown = ({
  value = 'All',
  onChange,
  options = DEFAULT_OPTIONS,
  className = '',
  selectClassName = 'min-w-[180px] sm:min-w-[220px]',
  id = 'statusFilter',
}) => {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <label className="text-sm text-gray-600 dark:text-slate-300 hidden sm:block" htmlFor={id}>Status</label>
      <select
        id={id}
        value={value}
        onChange={(e) => typeof onChange === 'function' && onChange(e.target.value)}
        className={`toolbar-control ${selectClassName}`}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
};

export default LoansStatusDropdown;
